// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

const AuthCallbackPage = () => {
  const { loginWithGoogleSession } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const user = await loginWithGoogleSession(sessionId);
        // clean the hash
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Bem-vindo(a), ${user.name}`);
        navigate(user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch (err) {
        toast.error("Não foi possível completar o login com o Google.");
        navigate("/login", { replace: true });
      }
    })();
  }, [loginWithGoogleSession, navigate]);

  return (
    <div className="min-h-screen bg-[#F4F1EB] flex items-center justify-center text-[#3A435E]">
      <div className="text-center">
        <div className="font-serif-display text-3xl text-[#0A1128]">
          Stay<span className="italic text-[#C5A059]">Zen</span>
        </div>
        <p className="mt-4 text-sm tracking-[0.2em] uppercase">A autenticar…</p>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
